import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import currencies from "../../../../lib/currencies/currencies";

import { Betbutton, FMiddle, Operation, Plus, Minus } from "./SonicStyled";

import useBetOperations from "../../bet/useBetOperations";
import useSound from "use-sound";
import playSound from "../audio/play.mp3";
import { logger } from '../../../../App'
export default function Sonic({
  betInfo,
  play,
  showOptions,
  click,
  handleNotification,
  toFix,
  minBet,
  maxBet,
  currency,
  sound,
  volume,
}) {
  const notifyText = false;
  // const [betBtnAnimation, setbetBtnAnimation] = useState(null);
  const [playPress, setplayPress] = useState(false);
  const [playUnpress, setplayUnpress] = useState(false);
  const [plusPress, setPlusPress] = useState(false);
  const [minusPress, setMinusPress] = useState(false);
  const [allowPlay, setAllowPlay] = useState(true);

  const st = useSelector((s) => s);

  const [useBet, plus, minus, , , handleButtonPress, handleButtonRelease] =
    useBetOperations(
      st.bet,
      true,
      sound,
      handleNotification,
      toFix,
      minBet,
      maxBet,
      currency,
    );
  const [playSFX] = useSound(playSound, { volume });

  const handlePlayAnimation = () => {
    logger.log("handlePlayAnimation", "allowPlay", allowPlay);
    if (allowPlay) {
      setAllowPlay(false);
      if (useBet > st.balance) {
        setTimeout(() => {
          setAllowPlay(true);
        }, 200);

        return handleNotification("Not enough balance");
      }
      if (sound) playSFX();

      setplayPress(true);
      setTimeout(() => {
        setplayPress(false);
        setplayUnpress(true);
        setTimeout(() => {
          setplayPress(false);
          setplayUnpress(false);
          setAllowPlay(true);
        }, 200);
      }, 200);
      play();
    }
  };
  useEffect(() => {
    setplayPress(false);
    setplayUnpress(false);
  }, [betInfo]);

  return (
    <Betbutton
      className="Betbutton"
      playPress={playPress}
      playUnpress={playUnpress}
    >
      <Operation
        onClick={showOptions ? click : minus}
        minusPress={minusPress}
        onTouchStart={() => {
          !notifyText && setMinusPress(true);
          handleButtonPress("acceleratableMinus");
        }}
        onTouchEnd={() => {
          setMinusPress(false);
          handleButtonRelease();
        }}
        onMouseDown={() => {
          !notifyText && setMinusPress(true);
          handleButtonPress("acceleratableMinus");
        }}
        onMouseUp={() => {
          setMinusPress(false);
          handleButtonRelease();
        }}
        onMouseLeave={() => {
          setMinusPress(false);
          handleButtonRelease();
        }}
      >
        <div style={{ width: "100%", height: "100%" }}>
          <Minus showOptions={showOptions} style={{ pointerEvents: "none" }} />
        </div>
      </Operation>

      <FMiddle onClick={showOptions ? null : handlePlayAnimation}>
        <p>play</p>
        <span  style={{ textTransform:'none' }}>
          {useBet} {currencies[currency]}
        </span>
      </FMiddle>
      <Operation
        onClick={plus}
        plusPress={plusPress}
        onTouchStart={() => {
          !notifyText && setPlusPress(true);
          handleButtonPress("acceleratablePlus");
        }}
        onTouchEnd={() => {
          setPlusPress(false);
          handleButtonRelease();
        }}
        onMouseDown={() => {
          !notifyText && setPlusPress(true);
          handleButtonPress("acceleratablePlus");
        }}
        onMouseUp={() => {
          setPlusPress(false);
          handleButtonRelease();
        }}
        onMouseLeave={() => {
          setPlusPress(false);
          handleButtonRelease();
        }}
      >
        <div>
          <Plus style={{ pointerEvents: "none" }} />
        </div>
      </Operation>
    </Betbutton>
  );
}
